import http, {configJson} from "./config/http-configs";

//visitor
export const addVisitor = (visitor) => {
    const url = "/manage/visitor/add"
    return http.post(url, visitor, configJson)
}
export const addBatchVisitor = (visitorList) => {
    const url = "/manage/visitor/batch/add"
    return http.post(url, visitorList, configJson)
}

export const updateVisitor = (visitor) => {
    const url = "/manage/visitor/update"
    return http.post(url, visitor, configJson)
}

export const deleteVisitor = (visitorId) => {
    return http.get('/manage/visitor/delete/' + visitorId)
}

// type：访客类型，common，一般访客；usual 常访人员；black黑名；provider 供应商
export const getVisitorListByType = (visitorType) => {
    const url = "/manage/visitor/search/"
    const data = {type: visitorType}
    return http.post(url, data, configJson)
}

//   type; current; size; tel; name;
export const getVisitorList = (postData) => {
    const url = "/manage/visitor/query/page"
    return http.post(url, postData, configJson)
}

export const getVisitorByBatch = (visitorCodes) => {
    const url = `/manage/visitor/list?visitorCodes=${visitorCodes}`
    return http.post(url, null, configJson)
}


export const visitorSearchByName = (name) => {
    const url = "/manage/visitor/search"
    const data = {name}
    return http.post(url, data, configJson)
}

// 模糊查询
export const visitorSearchByMatchName = (matchName) => {
    const url = "/manage/visitor/search"
    const data = {matchName}
    return http.post(url, data, configJson)
}

export const visitorSearchByPhoneNo = (tel) => {
    const url = "/manage/visitor/search"
    const data = {tel: tel}
    return http.post(url, data, configJson)
}

export const visitorSearchByIdCardNo = (idCardNo) => {
    const url = "/manage/visitor/search"
    const data = {ic: idCardNo}
    return http.post(url, data, configJson)
}

export const getVisitorByGateCardNo = (gateCardNo) => {
    const url = `/manage/visitor/search`
    const data = {cardNo: gateCardNo}
    return http.post(url, data, configJson)
}

export const searchVisitor = (searchData) => {
    const url = '/manage/visitor/search'
    return http.post(url, searchData, configJson)
}
